const navigationUtils = {
	getRouteWithActiveTab(path, tab) {
		return { path: path, query: { activeTab: tab } };
	},
	getPathWithActiveTab(path, tab) {
		return path + "?activeTab=" + tab;
	}
};

export {
	navigationUtils
}